/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions
import { Tree, useContentTree } from "./common";
const baseClassName = styleNames.base;
const componentClassName = 'content-tree';

/**
 * This is the component description.
 */
const ContentTree = ({
  id,
  className: userClassName,
  style,
  target,
  selectors,
  color
  // ...otherProps
}) => {
  const contentTree = useContentTree(target, selectors);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
    // {...otherProps}
  }, /*#__PURE__*/React.createElement(Tree, {
    color: color,
    tree: contentTree
  }));
};
ContentTree.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The selectors to use to extract the navigation tree from the content.
   */
  selectors: PropTypes.arrayOf(PropTypes.string),
  /**
   * The reference to the parent element.
   */
  target: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.node
  })]),
  /**
   * The color for the tree.
   */
  color: PropTypes.string
};
ContentTree.defaultProps = {
  selectors: ['h2', 'h3']
};
export default ContentTree;